module.exports = __webpack_public_path__ + "img/silo_img5.48729465.jpeg";